var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M11.272 11.272l25.456 25.456-1.414 1.414-3.928-3.926C29.017 35.406 26.556 36 24 36c-6.468 0-12.34-3.81-17.612-11.431a1 1 0 01-.07-1.02l.07-.118.293-.42c2.07-2.922 4.23-5.262 6.48-7.021l-3.303-3.304 1.414-1.414zM24 12c6.468 0 12.34 3.81 17.612 11.431a1 1 0 01.07 1.02l-.07.118-.293.42c-2.07 2.922-4.23 5.263-6.481 7.022l-3.946-3.947a8 8 0 00-10.956-10.956l-3.322-3.324C18.982 12.594 21.444 12 24 12zm-8 12a8 8 0 0012.063 6.893l-2.237-2.237a5 5 0 01-6.482-6.482l-2.237-2.237A7.963 7.963 0 0016 24zm8-5a5 5 0 014.656 6.827l-6.484-6.482A4.987 4.987 0 0124 19z", fill: "currentColor", stroke: "none", strokeWidth: 1, fillRule: "evenodd" })));
});
